import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import errorIcon from '../../assets/error-icon.png';

interface ErrorMessageModalProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  missingFields: string[];
  errorMessage?: string;
}

export const ErrorMessageModal = ({
  isModalOpen,
  toggleModal,
  missingFields,
  errorMessage,
}: ErrorMessageModalProps) => {
  const { t } = useTranslation();

  const isPlural = missingFields.length > 1;

  // Translate field names from i18n resource files
  const formattedFields = missingFields
    .map(field => {
      const key = `fields.${field.toLowerCase().replace(/\s+/g, '')}`;
      const translated = t(key);
      if (translated === key) console.warn('Missing translation key:', key);
      return translated;
    })
    .join(', ');

  // Determine final message
  const displayMessage = errorMessage
    ? errorMessage
    : t(`modal.${isPlural ? 'errorMessagePlural' : 'errorMessageSingular'}`, {
        fields: formattedFields,
      });
  const displayTitle = errorMessage
    ? t('modal.apiErrorTitle') // e.g., 'Error'
    : t('modal.errorTitle');
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={toggleModal}
      shouldCloseOnOverlayClick={false}
      contentLabel="Error Message"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 20px',
        },
        content: {
          position: 'relative',
          width: '500px',
          padding: '24px',
          borderRadius: '10px',
          inset: 'unset',
          backgroundColor: '#fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          textAlign: 'center',
        },
      }}
    >
      <h1
        style={{
          color: '#000',
          fontSize: '24px',
          fontWeight: '600',
          marginBottom: '18px',
        }}
      >
         {displayTitle}
      </h1>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '20px',
        }}
      >
        <img
          src={errorIcon}
          alt="Error Icon"
          style={{ width: '50px', height: '50px' }}
        />
        <p
          style={{
            fontSize: '16px',
            color: '#000',
            margin: 0,
            textAlign: 'left',
          }}
        >
          {displayMessage}
        </p>
      </div>

      <button
        onClick={toggleModal}
        style={{
          padding: '10px 20px',
          backgroundColor: '#c67b05',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {t('modal.close')}
      </button>
    </Modal>
  );
};
